<template>
  <el-dialog
      title="添加部门" destroy-on-close
      :visible.sync="createdDialog"
      width="860px">
    <el-form label-position="top" :model="dept" :rules="rules" ref="formRef" label-width="110px" class="demo-ruleForm">
      <div style="padding-left: 20px">
        <el-row>
          <el-col :span="8">
            <el-form-item label-width="100px" label="名称" prop="name">
              <el-input v-model="dept.name" style="width: 210px" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label-width="100px" label="所属部门" prop="parentIds">
              <el-cascader
                  v-model="dept.parentIds"
                  :options="deptTree"
                  @change="val => dept.parentId = val.at(-1)"
                  :props="{checkStrictly: true,value: 'id',label: 'name',children: 'children'}"
                  clearable>
              </el-cascader>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label-width="100px" label="主负责人" prop="directorId">
              <el-select
                  v-model="dept.directorId"
                  filterable placeholder="请输入" :loading="coachLoading"
                  remote reserve-keyword  :remote-method="(query) => selectCoach(query,1)">
                <el-option v-for="(coach,index) in coachList" :key="index" :label="coach.name" :value="coach.id">
                  {{coach.id}} - {{coach.name}}
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label-width="100px" label="负责人">
              <el-select
                  v-model="dept.viceDirectorId" clearable
                  filterable placeholder="请输入" :loading="coachLoading"
                  remote reserve-keyword  :remote-method="(query) => selectCoach(query,2)">
                <el-option v-for="(coach,index) in coachTwoList" :key="index" :label="coach.name" :value="coach.id">
                  {{coach.id}} - {{coach.name}}
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label-width="100px" label="部门类型">
              <el-select v-model="dept.flag" clearable placeholder="请选择">
                <el-option v-for="item in flagList" :key="Number(item.dictValue)" :label="item.dictLabel" :value="Number(item.dictValue)"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>
    <span slot="footer" class="dialog-footer">
        <el-button @click="createdDialog = false">取 消</el-button>
        <el-button type="danger" @click="createdDept">确 定</el-button>
      </span>
  </el-dialog>
</template>

<script>
import {selectCoach} from "../../../../api/contacts/user";
import {createdDept} from "../../../../api/contacts/dept";
export default {
  name: "CreatedDept",
  data() {
    return {
      dept:{
        flag:null,
        parentId:null,
        parentIds:null,
        name:"",
        directorId:null,
        viceDirectorId:null
      },
      deptTree:[],
      flagList:JSON.parse(localStorage.getItem("dict")).flagList,
      createdDialog: false,
      coachList:[],
      coachTwoList:[],
      coachLoading:false,
      rules:{
        name: [{required: true, message: "请输入名称！", trigger: "blur"}],
        parentIds: [{required: true, message: "请选择！", trigger: "blur"}],
        directorId: [{required: true, message: "请选择！", trigger: "blur"}],
      },
    }
  },
  methods: {
    createdDept(){
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          this.dept.flag = this.dept.flag || 0;
          createdDept(this.dept).then(val=>{
            if (val.status){
              this.$emit('succeed');
              this.createdDialog = false;
              this.$notify({title: '成功', message:val.data, type: 'success', offset: 40});
            }else {
              this.$notify({title: '失败', message:val.data, offset: 40});
            }
          })
        }
      })
    },
    selectCoach(val,type){
      this.coachLoading = true;
      selectCoach({coachName:val ? val:''}).then(val=>{
        this.coachLoading = false;
        if (type == 1){
          this.coachList = val.data;
        }else {
          this.coachTwoList = val.data;
        }
      })
    },
    openDialog(item,deptTree) {
      this.deptTree = deptTree;
      this.createdDialog = true;
      this.dept.parentId = item.id;
      this.selectCoach(null,1);
      this.selectCoach(null,2);
    },
  }
}
</script>

<style scoped>

</style>